/* Cookie consent banner (GH-1134). The landing's compact bottom-left card
   (pages/app-lending index.html, "COOKIE CONSENT") with the same two choices
   and copy. Shown until the visitor answers; any element with
   data-cookie-settings (Settings > Profile > Cookies) opens it again.
   Recording the choice is lib/cookieConsent.js; index.html's bootstrap turns
   it into the Google Consent Mode update. */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { currentConsent, saveConsentChoice } from '../lib/cookieConsent.js';

const PRIVACY_URL = 'https://dathent.ai/privacy';

export default function CookieConsentBanner() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(() => !currentConsent());

  useEffect(() => {
    const reopen = (event) => {
      if (!event.target?.closest?.('[data-cookie-settings]')) return;
      event.preventDefault();
      setOpen(true);
    };
    document.addEventListener('click', reopen);
    return () => document.removeEventListener('click', reopen);
  }, []);

  if (!open) return null;

  const choose = (choice) => {
    saveConsentChoice(choice);
    setOpen(false);
  };

  return (
    <div className="ckb" role="region" aria-label={t('cookieConsent.ariaLabel')}>
      <span className="ckb-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
          <path d="M8.5 8.5v.01" /><path d="M16 15.5v.01" /><path d="M12 12v.01" /><path d="M11 17v.01" /><path d="M7 14v.01" />
        </svg>
      </span>
      <div className="ckb-text">
        <span className="ckb-eyebrow">{t('cookieConsent.title')}</span>
        <span className="ckb-body">{t('cookieConsent.body')}</span>
      </div>
      <div className="ckb-actions">
        <a className="ckb-link" href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">{t('cookieConsent.privacy')}</a>
        <button type="button" className="ckb-btn ckb-btn-secondary" data-cookie-choice="necessary" onClick={() => choose('necessary')}>
          {t('cookieConsent.necessary')}
        </button>
        <button type="button" className="ckb-btn ckb-btn-primary" data-cookie-choice="accept" onClick={() => choose('accept')}>
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  );
}
